import { render, staticRenderFns } from "./BannerCarouselElement.vue?vue&type=template&id=1c488ccd&"
import script from "./BannerCarouselElement.vue?vue&type=script&lang=js&"
export * from "./BannerCarouselElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports